import React from 'react'
import LogoHeader from '../../components/LogoHeader/LogoHeader'
import cx from 'classnames'

import type { ModalProps } from './types'

function Modal({ children, error, hideStationLogo }: ModalProps) {
  const modalClass = cx('modal-style', { active: error })
  return (
    <div className={modalClass}>
      {!hideStationLogo && <LogoHeader />}
      <div className="content-style">{children}</div>
    </div>
  )
}

export default Modal
